module.exports = __webpack_public_path__ + "img/质量管理体系_01.0edefdf4.png";